<template>
    <div class="mc-browse">
        <ReleaseCarousel v-if="isHome" :releases="latestReleases" />
        <section v-if="isHome && followedNew.length" class="mc-follows-new" aria-labelledby="follows-new-title">
            <div class="mc-section-heading">
                <div><h2 id="follows-new-title"><span class="fas fa-bell fa-fw" aria-hidden="true"></span> Nouveautés de vos suivis</h2></div>
                <router-link to="/suivis" class="mc-follows-more">Voir mes suivis →</router-link>
            </div>
            <div class="mc-comic-grid">
                <article v-for="comic in followedNew" :key="comic.url" class="mc-comic-card item is-followed has-new">
                    <div class="mc-library-cover">
                        <router-link :to="comic.last_chapter.url" tabindex="-1" aria-hidden="true"><img :src="comic.thumbnail" :srcset="comic.thumbnail_srcset || null" sizes="(max-width: 359px) 112px, (max-width: 991px) 40vw, (max-width: 1199px) 22vw, 280px" :alt="comic.title" loading="lazy" decoding="async"></router-link>
                    </div>
                    <div class="mc-comic-info">
                        <h3 class="mc-series-title"><router-link class="filter mc-series-link" :title="comic.title" :to="comic.url">{{ comic.title }}</router-link></h3>
                        <p class="mc-series-new"><span class="fas fa-bell fa-fw" aria-hidden="true"></span> Nouveau chapitre</p>
                        <p v-if="comic.status" class="mc-series-meta">Statut : {{ comic.status }}</p>
                        <p v-if="comic.author" class="mc-series-meta"><strong>Auteur :</strong> {{ comic.author }}</p>
                        <p v-if="comic.artist && comic.artist !== comic.author" class="mc-series-meta"><strong>Artiste :</strong> {{ comic.artist }}</p>
                        <p class="mc-series-meta mc-series-latest">Dernier chapitre : <router-link :to="comic.last_chapter.url" class="mc-series-chapter" :title="comic.last_chapter.full_title">{{ comic.last_chapter.chapter != null ? comic.last_chapter.chapter + (comic.last_chapter.subchapter != null ? '.' + comic.last_chapter.subchapter : '') : comic.last_chapter.full_title }}</router-link></p>
                        <p v-if="comic.last_chapter.time" class="mc-series-meta">{{ comic.last_chapter.time }}</p>
                    </div>
                </article>
            </div>
        </section>
        <section v-for="group in categoryGroups" :key="group.key" class="mc-library" :aria-labelledby="'library-' + group.key">
            <div class="mc-section-heading"><div><h2 :id="'library-' + group.key">{{ group.label }}</h2></div><span class="mc-count">{{ group.comics.length }} œuvre{{ group.comics.length > 1 ? 's' : '' }}</span></div>
            <div v-if="isCatalog" id="all_comics_top_html" class="text-center"></div>
            <div class="mc-comic-grid">
                <article v-for="comic in group.comics" :key="comic.url" :class="'mc-comic-card item' + (comic.hidden ? ' hidden' : '') + (isFollowed(comic.slug) ? ' is-followed' : '') + (hasNewChapter(comic) ? ' has-new' : '')">
                    <div class="mc-library-cover">
                        <router-link :to="comic.url" tabindex="-1" aria-hidden="true"><img :src="comic.thumbnail" :srcset="comic.thumbnail_srcset || null" sizes="(max-width: 359px) 112px, (max-width: 991px) 40vw, (max-width: 1199px) 22vw, 280px" :alt="comic.title" loading="lazy" decoding="async"></router-link>
                    </div>
                    <div class="mc-comic-info">
                        <h3 class="mc-series-title">
                            <router-link class="filter mc-series-link" :title="comic.title" :to="comic.url">{{ comic.title }}</router-link>
                        </h3>
                        <p v-if="hasNewChapter(comic)" class="mc-series-new"><span class="fas fa-bell fa-fw" aria-hidden="true"></span> Nouveau chapitre</p>
                        <p v-if="comic.status" class="mc-series-meta">Statut : {{ comic.status }}</p>
                        <p v-if="comic.author" class="mc-series-meta"><strong>Auteur :</strong> {{ comic.author }}</p>
                        <p v-if="comic.artist && comic.artist !== comic.author" class="mc-series-meta"><strong>Artiste :</strong> {{ comic.artist }}</p>
                        <div v-if="comic.genres && comic.genres.length" class="mc-series-tags">
                            <router-link v-for="genre in comic.genres.slice(0, 6)" :key="genre.slug" :to="'/genres/' + genre.slug" class="mc-series-tag">{{ genre.name }}</router-link>
                        </div>
                        <p v-if="comic.last_chapter" class="mc-series-meta mc-series-latest">Dernier chapitre :
                            <router-link :to="comic.last_chapter.url" class="mc-series-chapter" :title="comic.last_chapter.full_title">{{ comic.last_chapter.chapter != null ? comic.last_chapter.chapter + (comic.last_chapter.subchapter != null ? '.' + comic.last_chapter.subchapter : '') : comic.last_chapter.full_title }}</router-link>
                        </p>
                        <a v-if="comic.id !== null" class="mc-series-edit" :href="reader.BASE_URL + 'admin/comics/' + comic.slug" :aria-label="'Modifier ' + comic.title"><span class="fas fa-edit" aria-hidden="true"></span></a>
                    </div>
                </article>
            </div>
            <p v-if="isHome && !group.comics.length" class="text-muted">Aucune œuvre dans cette catégorie pour le moment.</p>
            <div v-if="isCatalog" id="all_comics_bottom_html" class="text-center"></div>
        </section>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ReleaseCarousel from './ReleaseCarousel.vue';
import { hasNewChapter } from '../follows';

export default {
    name: "Comics",
    components: { ReleaseCarousel },
    mounted() {
        $('body').removeClass('body-reader hide-header');

        $('title').html(this.reader.SITE_NAME_FULL);
        $('meta[property="og:title"]').html(this.reader.SITE_NAME_FULL);
        this.$store.dispatch('fetchInfo', '/info');
        this.$store.dispatch('fetchComics', '/comics');
        this.comics.length && this.updateCustomHTML();
        document.addEventListener('visibilitychange', this.refreshCatalogue);
    },
    beforeUnmount() {
        document.removeEventListener('visibilitychange', this.refreshCatalogue);
    },
    beforeRouteLeave(to, from, next) {
        if(from.path !== to.path) {
            switch(from.path) {
                case '/comics':
                    this.reader.clearCustomHTML('all_comics_top_html');
                    this.reader.clearCustomHTML('all_comics_bottom_html');
                    break;
            }
        }
        next();
    },
    updated() {
        if (this.reader.$route.path === '/comics') {
            $('#nav-search').hide();
            $('#nav-filter').show();
        } else {
            $('#nav-search').show();
            $('#nav-filter').hide();
        }
        this.comics.length && this.updateCustomHTML();
    },
    data() {
        return {
            reader: this.$root,
        }
    },
    methods: {
        hasNewChapter,
        refreshCatalogue() {
            if (!document.hidden) this.$store.dispatch('fetchComics', '/comics');
        },
        updateCustomHTML() {
            if (this.isCatalog) {
                this.reader.updateCustomHTML('all_comics_top_html');
                this.reader.updateCustomHTML('all_comics_bottom_html');
            }
        },

    },
    computed: {
        categoryGroups() {
            if (!this.isHome) return [{key: 'all', label: this.pageTitle, comics: this.displayComics}];
            return [['ongoing', 'Séries en cours'], ['oneshot', 'One shot'], ['finished', 'Finis']]
                .map(([key, label]) => ({key, label, comics: this.displayComics.filter(comic => (comic.category || 'ongoing') === key)}));
        },
        isHome() { return this.reader.$route.path === '/'; },
        isCatalog() { return this.reader.$route.path === '/comics'; },
        pageTitle() { return this.reader.$route.name || this.reader.$route.params.genre || this.reader.$route.params.target || 'Nos œuvres'; },
        latestReleases() {
            // Keep the same 10-item window as the current production page.
            return this.$store.state.comics
                .filter(comic => comic.last_chapter && comic.last_chapter.published_on)
                .slice()
                .sort((a, b) => {
                    const dateA = Date.parse(a.last_chapter.published_on) || 0;
                    const dateB = Date.parse(b.last_chapter.published_on) || 0;
                    return dateB - dateA || a.title.localeCompare(b.title, 'fr');
                })
                .slice(0, 10);
        },
        displayComics() {
            if (!this.isHome) return this.comics;
            return [...this.$store.state.comics].sort((a, b) => {
                const dateA = a.last_chapter?.published_on ? Date.parse(a.last_chapter.published_on) || 0 : 0;
                const dateB = b.last_chapter?.published_on ? Date.parse(b.last_chapter.published_on) || 0 : 0;
                return dateB - dateA || a.title.localeCompare(b.title, 'fr');
            });
        },
        followedNew() {
            if (!this.isHome) return [];
            return this.$store.state.comics
                .filter(comic => this.isFollowed(comic.slug) && hasNewChapter(comic))
                .sort((a, b) => (Date.parse(b.last_chapter && b.last_chapter.published_on) || 0) - (Date.parse(a.last_chapter && a.last_chapter.published_on) || 0));
        },
        ...mapGetters([
            'comics',
            'socials',
            'isFollowed',
        ])
    }
}
</script>
